export function interpolateVectors(from, to, amount) {
    return from.map((fromValue, i) => amount * to[i] + (1 - amount) * fromValue);
}
export function findInterpolationBounds(input, values) {
    for (let i = 0; i < values.length - 1; i++) {
        if (input >= values[i] && input <= values[i + 1]) {
            return {
                index0: i,
                index1: i + 1,
                amount: (input - values[i]) / (values[i + 1] - values[i]),
            };
        }
    }
    throw new Error("Interpolation error");
}
//# sourceMappingURL=interpolation.js.map